<template>
<!-- 控制台首页 -->
  <div class="body">
    <navigation-bar></navigation-bar>
    <el-row class="main">
      <el-col :span="16">
        <!-- 操作指引 -->
        <div class="operation_guide">
          <span class="title">操作指引</span>
            <div class="line"></div>
            <div class="steps">
              <div class="step">
                <div class="step_content">
                  <img src="../../assets/console/guide_01.png" alt="">
                  <div>注册账号</div>
                </div>
              </div>
              <div class="step">
                <div class="step_content step_item" @click="enterDetail(2)">
                  <img src="../../assets/console/guide_02.png" alt="">
                  <div>账户认证</div>
                </div>
              </div>
              <div class="step">
                <div class="step_content step_item" @click="enterDetail(3)">
                  <img src="../../assets/console/guide_03.png" alt="">
                  <div>了解产品</div>
                </div>
              </div>
              <div class="step">
                <div class="step_content step_item" @click="enterDetail(4)">
                  <img src="../../assets/console/guide_04.png" alt="">
                  <div>在线签约</div>
                </div>
              </div>
              <div class="step">
                <div class="step_content">
                  <img src="../../assets/console/guide_05.png" alt="">
                  <div>深度上云</div>
                </div>
              </div>
            </div>
        </div>
        <div class="bottom_content">
          <el-row>
            <!-- 产品中心 -->
            <el-col :span="16">
              <div class="product_center">
                <span class="title">产品中心</span>
                <div class="menu">
                  <span :class='{ active:number==0}' @click="selectSwitch(0)">产品详情</span>
                  <span :class='{ active:number==1}' @click="selectSwitch(1)">已购资源</span>
                </div>
                <!-- 产品详情 -->
                <div class="content" v-if="number==0">
                  <div class="item" v-for="(item,index) in productList" :key="index" :class="{'item_right':index % 2 != 0}">
                    <div class="item_title">
                      <i>{{item.name}} </i>
                      <span @click="knowProductDetail(item.id)">了解详情 ></span>
                    </div>
                    <div class="item_desc">
                      {{item.description.length > 120 ? item.description.substring(0,80) + "..." : item.description}}
                    </div>
                    <div class="item_btn" @click="singupOnline(item.id)">在线签约</div>
                  </div>
                </div>
                <!-- 已购资源 -->
                <div class="content" v-if="number==1">
                  <div class="use_state">
                    <i>使用状态</i>
                    <span class="current_item">全部</span>
                    <!-- <span>运行中</span>
                    <span>已过期</span>
                    <span>已冻结</span> -->
                    <el-input v-model="searchContent" placeholder="请输入产品名称" size="small" style="width:250px">
                      <template #suffix>
                          <i class="el-input__icon el-icon-search" @click="queryResourceByConditions"></i>
                      </template>
                    </el-input>
                  </div>
                  <div class="table">
                    <el-table
                      :data="resourcesTable"
                      :header-cell-style="{background:'rgba(233, 239, 255, 1)',color:'#2A2A2A'}"
                      style="width: 100%">
                      <el-table-column
                        prop="contractId"
                        label="合同ID"
                        min-width="100">
                      </el-table-column>
                      <el-table-column
                        prop="productName"
                        label="产品名称">
                      </el-table-column>
                      <el-table-column
                        prop="runStatus"
                        label="状态">
                        <span class="state"><i class="el-icon-success"></i>运行中</span>
                      </el-table-column>
                      <el-table-column
                        label="操作">
                        <span @click="enterResourcesPage" class="operation_btn">管理资源</span>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="pagination">
                    <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="total">
                  </el-pagination>
                  </div>
                </div>
              </div>
            </el-col>
            <!-- 用户、公告信息 -->
            <el-col :span="8">
              <div class="user_notice">
                <!-- 用户 -->
                <div class="user_information">
                  <div class="user_data">
                    <img src="../../assets/console/user_avatar.png" alt="">
                    <div class="user_name">
                      <div>用户: {{userInfo.username}}</div>
                      <span :class="{certified : certificationStatus=='已认证'}">{{certificationStatus}}</span>
                    </div>
                  </div>
                  <div class="user_info">
                    <div @click="enterWorkWrder">工单信息（{{workTableData.length}}）</div>
                    <div @click="enterContractManagement">待签约（{{notSign.length}}）</div>
                    <div @click="enterContractManagement">待支付（{{notPay.length}}）</div>
                  </div>
                </div>
                <!-- 公告信息 -->
                <div class="notice_info">
                  <span class="title">公告信息</span>
                  <span class="more" @click="enterNoticeInfo">更多</span>
                  <div v-for="(item,index) in noticeInfoList" :key="index" @click="enterNoticeDetail(item)">
                    {{item.publishTime.substring(0, 10)+' '+item.title}}
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
    import { queryProductByType } from '@/api/channel/product.js'
    import { queryContractByConditions } from '@/api/console/contractManagement.js'
    import { queryResourceByConditions } from '@/api/console/resourceManagement.js'
    import { queryMemberInfoByUserId } from '@/api/console/accountCenter.js'
    import { queryNotificationByConditions } from '@/api/console/noticeInfo.js'
    import { queryTicketByUserID, queryAllTicketCategory, queryQuestionTypeByTicketCategoryId } from '@/api/console/supportServices.js'
    import NavigationBar from '../../components/console/navigationBar.vue'
    import token from '@/utils/token.js'
    export default {
        data() {
            return {
                searchContent: '', //搜索内容
                resourcesTable: [], //表格数据
                number: 0,
                currentPage: 1, //当前页
                pageSize: 5, //每页条数
                total: 0, //总条数
                productList: [], //产品列表
                userInfo: {},//用户信息
                certificationStatus: '',//用户认证状态
                workTableData: [],
                tableData: [],
                notSign: [],
                notPay: [],
                noticeInfoList: [],//公告列表
            }
        },
        components: {
            NavigationBar
        },
        created() {
            this.getData();
        },
        methods: {
            getData() {
              //查询用户信息
              let userId = token.getUser().id;
              queryMemberInfoByUserId(userId).then(res => {
                this.userInfo = res.data.info;
                if(this.userInfo.personStatus == '0' || this.userInfo.companyStatus == '0') {
                  this.certificationStatus = '未认证，请尽快认证'
                } else if(this.userInfo.personStatus == '1' || this.userInfo.companyStatus == '1') {
                  this.certificationStatus = '认证审核中'
                } else {
                  this.certificationStatus = '已认证'
                }
              })
              //查询产品列表
              this.queryProductList();
              //查询资源列表
              this.queryResourceByConditions();
              //查询待签约数量
              this.queryContract();
              this.querywork();
              //查询公告列表
              this.queryNoticeList();
            },
            //步骤导航
            enterDetail(i) {
              if(i == 2) {
                this.$router.push({path: '/accountCenter',query:{index: 1}});
              } else if (i == 3 || i == 4) {
                this.$router.push({path: '/productManagement'})
              }
            },
            //产品中心切换
            selectSwitch(i) {
              this.number = i;
            },
            //查询产品列表
            queryProductList() {
              let type = 0;
              queryProductByType(type).then(res => {
                  this.productList = res.data.list;
              })
            },
            //了解产品详情
            knowProductDetail(id) {
              this.$router.push({
                  path: '/productDetail',
                  query: {
                      id
                  }
              });
            },
            //进入在线签约
            singupOnline(id) {
              this.$router.push({path: '/onlineSignup',query: {id:id}})
            },
            //查询资源列表
            queryResourceByConditions() {
              let param = {
                name: this.searchContent,
                nowPage: this.currentPage,
                pageSize: this.pageSize,
                runStatus: '',
                userId: token.getUser().id
              }
              queryResourceByConditions(param).then(res => {
                // console.log('资源列表---', res);
                this.resourcesTable = res.data.list;
                this.total = res.data.list.length;
              })
            },
            //进入资源管理页面
            enterResourcesPage() {
              this.$router.push({ path: '/resourceManagement'})
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.queryResourceByConditions();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryResourceByConditions();
            },
            //用户
            enterWorkWrder() {//进入我的工单页面
              this.$router.push({path: '/supportServices',query:{ index: 1}});
            },
            enterContractManagement() {//进入合同管理页面
              this.$router.push({ path: '/contractManagement'})
            },
            //查询待签约、待支付合同数量
            queryContract() {
              let param1 = {//待签约
                name: '',
                nowPage: 1,
                pageSize: 100,
                payStatus: '',
                signStatus: 'SIGNING',
                useStatus: '',
                userId: token.getUser().id
              }
              let param2 = {//待支付
                name: '',
                nowPage: 1,
                pageSize: 100,
                payStatus: '0',
                signStatus: '',
                useStatus: '',
                userId: token.getUser().id
              }
              this.queryContractByConditions(param1,1);
              this.queryContractByConditions(param2,2);
            },
            queryContractByConditions(param, val) {
              queryContractByConditions(param).then(res => {
                if(res.data.list.length > 0) {
                  if(val == 1) {//未签约
                    this.notSign = this.getFirstNode(res.data.list);
                  } else if(val == 2) {//未支付
                    this.notPay = this.getFirstNode(res.data.list);
                  }
                } else {
                  this.contractTableData = [];
                }
              })
            },
            async querywork() {
              let userId = token.getUser().id;
              let res = await queryTicketByUserID(userId);//查工单列表
              this.tableData = res.data.list;
              let firstStepRes = await queryAllTicketCategory();//查问题所属产品列表
              this.firstStepList = firstStepRes.data.list;
              for(let i = 0; i < this.tableData.length; i++) {
                for (let j = 0; j < this.firstStepList.length; j++) {
                  if(this.tableData[i].ticketCategoryId = this.firstStepList[j].id) {
                    this.tableData[i].ticketCategory = this.firstStepList[j].name;
                    let res = await queryQuestionTypeByTicketCategoryId(this.firstStepList[j].id);
                    this.secondStepList = res.data.list;
                    for(let index = 0; index < this.secondStepList.length; index++) {
                      if(this.tableData[i].questionTypeId = this.secondStepList[index].id) {
                        this.tableData[i].questionType = this.secondStepList[index].name;
                      }
                    }
                  }
                }
              }
              this.workTableData = this.tableData;
            },
            //获取一级节点
            getFirstNode(data) {
              let firstNodeList = []
              for (let i = 0; i < data.length; i++) {
                  if (data[i].type === 0) {
                    let module = {
                      ...data[i],
                      key: Date.now(),
                      children: [],
                    }
                      firstNodeList.push(module)
                      module.children = this.getNextNode(data, data[i])
                  }
              }
              return firstNodeList
            },
            //获取二级及以下节点
            getNextNode(data, father) {
              let nextNodeList = []
              for (let i = 0; i < data.length; i++) {
                if (data[i].contractId === father.contractId && data[i].type != 0) {
                  let module = {
                    ...data[i],
                    key: Date.now(),
                    children: [],
                  }
                  nextNodeList.push(module)
                }
              }
              return nextNodeList
            },
            //查询公告列表
            queryNoticeList() {
              let param = {
                isPublish: "Y",
                typeId: 0,
                nowPage: 1,
                pageSize: 5,
                title: ""
              }
              queryNotificationByConditions(param).then(res=> {
                this.noticeInfoList = res.data.list;
              })
            },
            //进入公告信息
            enterNoticeInfo() {
              this.$router.push({
                path: '/noticeInfo'
              })
            },
            //进入公告详情页
            enterNoticeDetail(item) {
              this.$router.push({
                path: '/noticeInfo/noticeDetail',
                query: {
                    item: JSON.stringify(item)
                }
              });
            },
        }
    }
</script>
<style lang="scss" scoped="scoped">
    .body {
        width: 100%;
        height: 100%;
        margin-top: 80px;
        background-color: #F6F6F7;
    }
    
    .main {
        display: flex;
        justify-content: center;
    }
    /* 操作指引 */
    
    .operation_guide {
        position: relative;
        height: 160px;
        padding: 0 10%;
        margin-top: 20px;
        border: 1px solid rgba(212, 212, 212, 1);
        background-color: #fff;
    }
    
    .title {
        position: absolute;
        top: 20px;
        left: 20px;
        font-size: 16px;
        color: #4F4F4F;
    }
    
    .line {
        width: 100%;
        height: 2px;
        margin-top: 75px;
        background: linear-gradient(to right, rgba(241, 74, 79, 1), rgba(253, 99, 205, 1), rgba(219, 93, 255, 1), rgba(77, 145, 255, 1), rgba(77, 180, 255, 1), rgba(77, 213, 220, 1));
    }
    
    .steps {
        position: absolute;
        top: 47px;
        width: 80%;
    }
    
    .step {
        float: left;
        width: 20%;
    }
    
    .step_content {
        width: 59px;
        margin: auto;
    }
    
    .step_item:hover {
        cursor: pointer;
    }
    
    .step_content img {
        height: 59px;
        margin-bottom: 10px;
    }
    
    .step_content div {
        font-size: 14px;
        color: #4F4F4F;
    }
    /* bottom_content */
    
    .bottom_content {
        margin-top: 20px;
    }
    /* 产品中心 */
    
    .product_center {
        /* height: 555px; */
        padding: 20px;
        margin-bottom: 200px;
        border: 1px solid rgba(212, 212, 212, 1);
        background-color: #fff;
    }
    
    .menu {
        height: 32px;
        margin-top: 50px;
        border-bottom: 1px solid rgba(212, 212, 212, 1);
        font-size: 14px;
        color: #333;
        line-height: 32px;
    }
    
    .menu span {
        display: inline-block;
        height: 32px;
        padding: 0 10px;
    }
    
    .menu span:hover {
        cursor: pointer;
    }
    
    .active {
        color: #5783EE;
        border-bottom: 1px solid #5783EE;
    }
    /* 产品详情 */
    
    .content {
        width: 100%;
        margin-top: 30px;
        overflow: hidden;
    }
    
    .item {
        float: left;
        box-sizing: border-box;
        position: relative;
        width: 48.5%;
        height: 153px;
        padding: 15px 15px 0;
        margin-bottom: 20px;
        border: 1px solid #E5E5E5;
    }
    
    .item_right {
        float: right;
    }
    
    .item_title {
        height: 30px;
        border-bottom: 1px solid #E5E5E5;
        line-height: 30px;
    }
    
    .item_title i {
        font-size: 16px;
        font-style: normal;
        color: #2A2A2A;
    }
    
    .item_title span {
        float: right;
        font-size: 10px;
        color: #507DF1;
    }
    
    .item_title span:hover {
        cursor: pointer;
    }
    
    .item_desc {
        margin-top: 5px;
        font-size: 10px;
        color: #7F7F7F;
    }
    
    .item_btn {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 126px;
        height: 38px;
        background-color: rgba(80, 125, 241, 1);
        font-size: 14px;
        color: #fff;
        text-align: center;
        line-height: 38px;
    }

    .item_btn:hover {
      background-color: #6089F3;
      cursor: pointer;
    }

    /* 已购资源 */
    
    .use_state {
        height: 32px;
        /* background-color: rgba(87, 131, 238, 1); */
        font-size: 12px;
        color: #2A2A2A;
        line-height: 32px;
    }
    
    .use_state i {
        margin-right: 20px;
        font-style: normal;
        color: #4F4F4F;
    }
    
    .use_state span {
        display: inline-block;
        width: 100px;
        height: 32px;
        margin-right: 1px;
        background-color: rgba(233, 239, 255, 1);
        text-align: center;
    }

    .use_state .current_item {
      background-color: #5984EC;
      color: #fff;
    }

    .use_state span:hover {
      cursor: pointer;
    }
    
    .el-input {
      float: right;
    }

    .el-input i {
      margin-right: 0;
    }
    
    .table {
      border-left: 1px solid #E5E5E5;
      border-right: 1px solid #E5E5E5;
    }

    .el-table {
        margin-top: 20px;
        font-size: 12px;
        /deep/ th {
            padding: 4px;
            font-weight: 400;
        }
        /deep/ td {
            padding: 10px;
        }
    }

    .state {
      color: #039F00;
    }

    .operation_btn {
      color: #537EEE;
    }

    .operation_btn:hover {
      text-decoration: underline;
      cursor: pointer;
    }
    
    .pagination {
        display: flex;
        justify-content: right;
        margin-top: 20px;
    }
    /* 用户、公告信息 */
    
    .user_notice {
        margin-left: 20px;
    }
    /* 用户 */
    
    .user_information {
        position: relative;
        height: 188px;
        border: 1px solid #E5E5E5;
        background: url(../../assets/console/background_01.png) no-repeat top right;
        background-color: #fff;
    }
    
    .user_data img {
        width: 42px;
        height: 42px;
        margin: 20px 20px 0;
    }
    
    .user_name {
        display: inline-block;
    }
    
    .user_name div {
        font-size: 16px;
        font-style: normal;
        color: #4F4F4F;
    }
    
    .user_name span {
        font-size: 12px;
        color: #E62D31;
        text-decoration: underline;
    }

    .user_name .certified {
      color: #6DD747;
    }
    
    .user_info {
        position: absolute;
        bottom: 0;
        width: 100%;
    }
    
    .user_info div {
        float: left;
        width: 33%;
        height: 62px;
        margin-right: 0.3%;
        background-color: rgba(87, 131, 238, 1);
        font-size: 14px;
        color: #fff;
        text-align: center;
        line-height: 62px;
    }
    
    .user_info div:hover {
        cursor: pointer;
        background-color: #6089F3;
    }
    /* 公告信息 */
    
    .notice_info {
        position: relative;
        height: 213px;
        padding: 50px 30px 30px;
        margin-top: 20px;
        border: 1px solid #E5E5E5;
        background-color: #fff;
    }
    
    .more {
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 12px;
      color: #507DF1;
    }

    .more:hover {
      cursor: pointer;
      text-decoration: underline;
    }

    .notice_info div {
        font-size: 12px;
        color: #4F4F4F;
        line-height: 30px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    
    .notice_info div:hover {
        color: #537EEE;
        cursor: pointer;
    }
</style>
<style lang="scss">
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #537EEE;
  }
</style>